import { parseRobloxTopChartsResponse } from '@intelligence/v3/services/robloxTopCharts';

import type { RecordItemType } from '@intelligence/components/SearchRecent/type';

export const transRobloxTopChartsTableDataForSearch = (response: any): RecordItemType[] => {
  const { list } = parseRobloxTopChartsResponse(response);

  return list.map((item) => ({
    id: item?.game_id || '',
    imgSrc: item?.cover || '',
    lineOneStr: item?.entity_name || item?.game_id || '-',
    lineTwoStr: item?.publisher || '-',
    showImgTwo: false,
  }));
};
